<template>
  <div class="yt-company-container">
    <div class="content-box">
      <div class="introduce-wrap">
        <Collapse></Collapse>
        <div class="company-info-row">
          <div class="info-block">
            <div class="info-value">10万+</div>
            <div class="info-title">服务电站</div>
          </div>
          <div class="info-block">
            <div class="info-value">2万+</div>
            <div class="info-title">行业用户</div>
          </div>
          <div class="info-block">
            <div class="info-value">100+</div>
            <div class="info-title">合作企业</div>
          </div>
          <div class="info-block">
            <div class="info-value">50+</div>
            <div class="info-title">荣誉资质</div>
          </div>
        </div>
      </div>

      <!-- 焱图理念 -->
      <div class="block-wrap">
        <div class="block-title page-block-title">焱图理念</div>
        <div class="block-content">
          <div class="block-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/values.png"
              alt=""
            />
            <div class="text-block">
              <div class="block-row-title">核心价值观</div>
              <div class="block-row-desc">创新 专业 进取 共赢</div>
            </div>
          </div>

          <div class="block-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/mission.png"
              alt=""
            />
            <div class="text-block">
              <div class="block-row-title">核心使命</div>
              <div class="block-row-desc">让工作更安全、更简单、更高效</div>
            </div>
          </div>

          <div class="block-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/vision.png"
              alt=""
            />
            <div class="text-block">
              <div class="block-row-title">企业愿景</div>
              <div class="block-row-desc">致力于成为领先的新能源智能服务商</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 发展历程 -->
      <div class="develop-progress-wrap">
        <div class="block-title block-progress page-block-title">发展历程</div>
        <Progress class="pc-progress"></Progress>
        <div class="mobile-progress">
          <div class="timeline">
            <div class="time-line-item">
              <div class="item-title">2025年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">
                  焱图清洗无人机荣获AIPV 2024年智能光伏示范产品
                </div>
                <div class="list-item">
                  焱图智能机器人（盐城）有限公司成立
                </div>
                <div class="list-item">清洗机器人第三代开始量产</div>
              </div>
            </div>

            <div class="time-line-item">
              <div class="item-title">2024年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">
                  推出光伏行业首个人工智能大模型——“绿能百科”
                </div>
                <div class="list-item">
                  荣获“2023年光伏系统集成智能示范企业”
                </div>
                <div class="list-item">
                  光伏一点通荣获“2023年分布式光伏智能示范产品”
                </div>
                <div class="list-item">推出光伏清洗机器人和无人机</div>
              </div>
            </div>

            <div class="time-line-item">
              <div class="item-title">2023年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">成为大疆生态合作伙伴</div>
                <div class="list-item">
                  荣获2023好光伏“年度新锐企业”奖
                </div>
              </div>
            </div>

            <div class="time-line-item">
              <div class="item-title">2022年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">8月，喜获苏州市姑苏创新创业领军人才</div>
                <div class="list-item">12月，获得高新技术企业认定</div>
              </div>
            </div>

            <div class="time-line-item">
              <div class="item-title">2021年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">
                  4月，推出无人机智能飞行控制APP产品及在线实景建模云平台
                </div>
                <div class="list-item">7月，推出智能光伏运维巡检产品</div>
                <div class="list-item">
                  10月，喜获“智汇苏高新”创新创业大赛第一名
                </div>
                <div class="list-item">推出“光伏一点通”产品</div>
                <div class="list-item">
                  11月，喜获苏州市高新区科技创新创业领军人才
                </div>
              </div>
            </div>

            <div class="time-line-item">
              <div class="item-title">2020年</div>
              <div class="item-line"></div>
              <div class="item-content">
                <div class="list-item">公司成立</div>
                <div class="list-item">11月，推出AI图像分析平台</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="block-wrap">
        <div class="business-block-title page-block-title">业务分布</div>
        <div class="business-desc">
          用户数量20000+，服务项目100000+，全国省份全覆盖
        </div>
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/map.png"
          class="map-bg"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import Collapse from "./components/collapse.vue";
import Progress from "./components/progress.vue";
export default {
  components: {
    Collapse,
    Progress,
  },
  data() {
    return {
      newsActive: false,
      honorsActive: false,
      phoneActive: false,
    };
  },
};
</script>

<style lang="stylus" scoped>
.yt-company-container {
  width:100%;
  // height:100%;
  // .content-box {
  //   .content-box-top-banner {
  //     height:33.75rem;
  //     margin-top:6.18rem;
  //     width:100%;
  //     display:flex;
  //     align-items:center;
  //     background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/company_profile_banner.png");
  //     background-repeat:no-repeat;
  //     position:relative;
  //     .text-block {
  //       color:#fff;
  //       position:absolute;
  //       top:10.812rem;
  //       left:16.375rem;
  //       .text-block-title {
  //         font-size:2.25rem;
  //         font-weight:bold;
  //         letter-spacing:2px;
  //         margin-bottom:1.25rem;
  //       }
  //       .text-block-desc {
  //         font-size:1.3rem;
  //         letter-spacing:2px;
  //       }
  //     }
  //   }
  //   .tab-bar {
  //     background: #10151B;
  //     width:100%;
  //     .tab-box {
  //       display:flex;
  //       width:87.5rem;
  //       margin:0 auto;

  //       .active {
  //         background: rgba(255,255,255,0.15);
  //       }
  //       .tab-item {
  //         padding:1.625rem 0 1.18rem 1.875rem;
  //         color:#FFFFFF;
  //         width:10.625rem;
  //         cursor:pointer;
  //         img {
  //           margin-bottom:7px;
  //           transition: transform 0.5s ease;
  //           ransform-style: preserve-3d;
  //         }

  //       }
  //       .tab-item:hover {
  //         background: rgba(255, 255, 255, 0.15);
  //         img {
  //           transform: rotateY(360deg);
  //         }
  //       }
  //     }
  //   }
  // }
  .introduce-wrap {
    max-width:var(--main-width);
    margin:3.56rem auto 0;
    width:84%;
    .company-info-row {
      display:flex;
      flex-wrap:wrap;
      margin-top:4.18rem;
      padding-bottom:2.625rem;
      justify-content:center;
      border-bottom: 1px solid #E5E5E5;
      gap:2.375rem;
      .info-block {
        display:flex;
        flex-direction:column;
        text-align:center;
        width:16rem;
      }
      .info-value {
        font-size:2.5rem;
        color:#2372E9;
        font-weight:bold;
        margin-bottom:0.625rem;
        span {
          color:#888888;
          font-size:1.25rem;
          margin-left:10px;
        }
      }
      .info-title {
        font-size:1rem;
        color:#333;
      }
    }
  }

  .develop-progress-wrap {
    width:100%;
    min-height:42.56rem;
    height:auto;
    padding-bottom:3rem;
    display:flex;
    justify-content:center;
    align-items:center;
    background-size:cover;
    flex-direction:column;
    background-repeat:no-repeat;
    background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/progress_bg.png");
    .block-title {
      position:relative;
      text-align:center;
      letter-spacing:2px;
      // font-size:2.625rem;
      font-weight:bold;
    }
    // .block-title::after {
    //   content:"";
    //   position:absolute;
    //   width: 55px;
    //   left:50%;
    //   transform:translateX(-50%);
    //   top:80px;
    //   height: 3px;
    //   background: #2372E9;
    // }
    .mobile-progress {
      margin-top:36px;
      display:none;
      width:100%;
      box-sizing:border-box;
      .timeline {
        .time-line-item {
          margin-bottom:28px;
          &:last-child {
            margin-bottom:0;
          }
          .item-title {
            color:#2372E9;
            font-size:24px;
            font-weight:bold;
            margin-bottom:12px;
          }
          .item-line {
            width:100%;
            height:1px;
            background:#E6E5E5;
            margin-bottom:16px;
          }
          .item-content {
            .list-item {
              position:relative;
              padding-left:16px;
              line-height:22px;
              font-size:14px;
              color:#333;
            }
            .list-item::before {
              position:absolute;
              content:"";
              width:6px;
              height:6px;
              left:0;
              top:8px;
              border-radius:50%;
              background:#666666;
            }
            .list-item:not(:last-child) {
              margin-bottom:12px;
            }
          }
        }
      }
    }
  }

  .block-wrap {
    padding:4.625rem 0 3.06rem;
    max-width:var(--main-width);
    width:84%;
    margin:0 auto;
    display: flex;
    flex-direction: column;
    .business-desc {
      color:#666666;
      text-align:center;
      margin-top:2.81rem;
    }
    .business-block-title {
      position:relative;
      text-align:center;
      letter-spacing:2px;
      font-weight:bold;
    }
    // .business-block-title::after {
    //   content:"";
    //   position:absolute;
    //   width: 55px;
    //   left:50%;
    //   transform:translateX(-50%);
    //   top:80px;
    //   height: 3px;
    //   background: #2372E9;
    // }
    .block-title {
      position:relative;
      text-align:center;
      letter-spacing:2px;
      font-weight:bold;
      // font-size:2.625rem;
    }
    // .block-title::after {
    //   content:"";
    //   position:absolute;
    //   width: 55px;
    //   left:50%;
    //   transform:translateX(-50%);
    //   top:80px;
    //   height: 3px;
    //   background: #2372E9;
    // }
    .block-content {
      display:flex;
      justify-content:space-between;
      .block-row {
        position:relative;
        margin-right:25px;
        margin-top:4rem;
        img {
          width:100%;
        }
        .block-row-title {
          margin-bottom:3.125rem;
          position:relative;
        }
        .block-row-title::after {
          content:"";
          width: 80px;
          height: 1px;
          background: #DBDBDB;
          position:absolute;
          left:0;
          bottom:-1.18rem;
        }
        .block-row-title::before {
          content:"";
          width: 30px;
          height: 3px;
          background: #2372E9;
          position:absolute;
          left:0;
          bottom:-1.18rem;
        }
      }
     .text-block {
      position:absolute;
      top:3.81rem;
      left:2.16rem;
      .block-row-desc {
        font-size:1.25rem;
        font-weight:bold;
        color:#333;
      }
     }
    }
    .map-bg {
      max-width:65%;
      margin:0 auto;
    }
  }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {

  .block-content {
    flex-wrap:wrap;
    justify-content:center;
  }
}
@media only screen and (max-width: 768px) {
  .yt-company-container {

  .block-content {
    flex-wrap:wrap;
    justify-content:center;
  }

  .content-box-top-banner {
    .text-block {
      top:42px !important;
      left:26px !important;
    }
    .text-block-title {
      font-size:24px !important;
    }
  }
  .company-info-row {
    margin-top:0 !important;
    padding-left:15px !important;
    justify-content:flex-start !important;
    border-bottom:none !important;
    gap:12px !important;
    .info-block {
      text-align:left !important;
      padding:13px;
      width:38% !important;
      background-color:#FFFFFF;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.06);
      .info-value {
        font-size:26px !important;
        span {
          font-size:14px !important;
        }
      }
    }
  }
  .introduce-wrap {
    margin-top:30px !important;
  }
  .introduce-wrap,.accordion-wrap {
    width:auto !important;
  }
  .time-line-item {
    width:100%;
  }
  .develop-progress-wrap {
    height:auto !important;
    min-height:auto !important;
    padding-bottom:30px;
    background-size:cover;
  }
  .block-wrap {
      padding:0 0.6rem !important;
      width:auto !important;

      .block-row {
        margin:2rem auto 0 !important;
        width:100% !important;
      }

      .business-desc {
        font-size:13px;
        margin:20px 0;
      }
    }
    .block-title {
        font-size:22px !important;
        line-height:30px;
        width:100%;
        background-color:#fff;
      }

      .block-title::after {
        top:40px !important;
      }
      .business-block-title {
        font-size:22px !important;
        line-height:50px;
        width:100%;
        margin-top:30px;
        background-color:#fff;
      }

      .business-block-title::after {
        top:55px !important;
      }
      .pc-progress {
        display:none !important;
      }
      .mobile-progress {
        display:block !important;
        padding:0 15px 45px;
        box-sizing:border-box;
      }
      .block-progress {
        line-height:55px !important;
      }
      .block-progress::after {
        top: 50px !important;
      }
      .map-bg {
         width:340px !important;
         margin-top:5px;
      }
      }
}
</style>
